import { render, staticRenderFns } from "./SubCategoryManage.vue?vue&type=template&id=1d11a494&scoped=true"
import script from "./SubCategoryManage.vue?vue&type=script&lang=js"
export * from "./SubCategoryManage.vue?vue&type=script&lang=js"
import style0 from "./SubCategoryManage.vue?vue&type=style&index=0&id=1d11a494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d11a494",
  null
  
)

export default component.exports